"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = ProductPlan;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _reactNative = require("react-native");
var _moment = _interopRequireDefault(require("moment"));
require("moment/locale/es-us");
require("moment/locale/en-gb");
var _styles = require("@sart/styles");
var _content = require("@sart/content");
var _client = _interopRequireDefault(require("@sart/client"));
var _Text = _interopRequireDefault(require("./Text"));
var _Label = _interopRequireDefault(require("./Label"));
var _Price = _interopRequireDefault(require("./Price"));
var _Space = _interopRequireDefault(require("./Space"));
var _Anchor = _interopRequireDefault(require("./Anchor"));
var _Button = _interopRequireDefault(require("./Button"));
var _StoredPaymentMethod = _interopRequireDefault(require("./StoredPaymentMethod"));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var getProductRenewDate = function getProductRenewDate(startDate, frequency, frequencyUnit) {
  var renewDate = (0, _moment["default"])(startDate).utc();
  while (renewDate.diff((0, _moment["default"])().utc()) < 0) {
    renewDate = renewDate.add(frequency, frequencyUnit.toLowerCase());
  }
  return renewDate;
};
var formatDate = function formatDate(date, language) {
  if (date) {
    var formatted = (0, _moment["default"])(date).utc().locale(language).format('ddd D MMM');
    var elements = formatted.split('.').join('').split(' ');
    elements[0] = elements[0][0].toUpperCase() + elements[0].slice(1);
    elements[2] = elements[2][0].toUpperCase() + elements[2].slice(1);
    return elements.join(' ');
  }
  return null;
};
function ProductPlan(props) {
  var product = props.product,
    onEditProduct = props.onEditProduct,
    onEditPayment = props.onEditPayment,
    onCancelProduct = props.onCancelProduct,
    productContainer = props.productContainer,
    labelStyle = props.labelStyle,
    nameStyle = props.nameStyle,
    textStyle = props.textStyle,
    buttonTitleStyle = props.buttonTitleStyle,
    buttonStyle = props.buttonStyle,
    cancelStyle = props.cancelStyle,
    addOn = props.addOn;
  var content = (0, _content.useContent)();
  var language;
  if (_client["default"].cache.language === 'en') {
    language = 'en-gb';
  } else if (_client["default"].cache.language === 'es') {
    language = 'es-us';
  }
  function getDisplayDetailsForLanguage(addOn) {
    //Get the display details for the language that is selected in the cache
    var displayDetails = undefined;

    //identify the correct display details to use based on language
    if (addOn.product.displayDetails) {
      addOn.product.displayDetails.map(function (detail) {
        if (detail.language === _client["default"].cache.language) {
          displayDetails = detail;
        }
      });
    }
    return displayDetails;
  }
  function getColourByCategory(displayDetails, category) {
    if (!category) {
      return undefined;
    }
    var toReturn = undefined;
    var hexCodeRegex = /^#(?:[0-9a-fA-F]{3}){1,2}$/;

    //get the relevant font colour based on the category
    if (displayDetails && displayDetails.colors && displayDetails.colors.length) {
      displayDetails.colors.map(function (color) {
        //we also only accept hex values, so use regex to make sure it matches the pattern
        if (color.category === category && hexCodeRegex.test(color.color)) {
          toReturn = color.color;
        } else if (color.category === category && color.color === 'transparent') {
          return undefined;
        }
      });
    }
    return toReturn;
  }
  var displayDetails = getDisplayDetailsForLanguage(addOn);
  var titleColour = getColourByCategory(displayDetails, 'TitleText');
  var descriptionColour = getColourByCategory(displayDetails, 'DescriptiveText');
  var backgroundColour = getColourByCategory(displayDetails, 'Background');
  var accentColour = getColourByCategory(displayDetails, 'Accent');
  return /*#__PURE__*/_react["default"].createElement(_reactNative.View, {
    style: [productContainer ? productContainer : styles.container, backgroundColour ? {
      backgroundColor: backgroundColour
    } : {}]
  }, /*#__PURE__*/_react["default"].createElement(_Label["default"], {
    style: [labelStyle ? labelStyle : styles.label, descriptionColour ? {
      color: descriptionColour
    } : {}]
  }, content.product.plan), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    style: [nameStyle ? nameStyle : styles.name, titleColour ? {
      color: titleColour
    } : {}]
  }, product.name), /*#__PURE__*/_react["default"].createElement(_reactNative.View, {
    style: styles.row
  }, /*#__PURE__*/_react["default"].createElement(_reactNative.View, {
    style: styles.column
  }, /*#__PURE__*/_react["default"].createElement(_Label["default"], {
    style: [labelStyle ? labelStyle : styles.label, descriptionColour ? {
      color: descriptionColour
    } : {}]
  }, content.product.expiryDate), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    style: [textStyle ? textStyle : styles.text, titleColour ? {
      color: titleColour
    } : {}]
  }, product.expiration ? formatDate(product.expiration, language) : formatDate(getProductRenewDate(product.startDate, product.frequency, product.frequencyUnit), language))), /*#__PURE__*/_react["default"].createElement(_reactNative.View, {
    style: styles.column
  }, /*#__PURE__*/_react["default"].createElement(_Label["default"], {
    style: [labelStyle ? labelStyle : styles.label, descriptionColour ? {
      color: descriptionColour
    } : {}]
  }, content.product.price), /*#__PURE__*/_react["default"].createElement(_Price["default"], {
    style: [textStyle ? textStyle : styles.text, titleColour ? {
      color: titleColour
    } : {}],
    value: product.price,
    code: product.code
  }))), /*#__PURE__*/_react["default"].createElement(_Space["default"], {
    height: 12
  }), product.storedPayment && /*#__PURE__*/_react["default"].createElement(_StoredPaymentMethod["default"], {
    payment: product.storedPayment,
    editable: true,
    onEditPayment: onEditPayment
  }), /*#__PURE__*/_react["default"].createElement(_Space["default"], {
    height: 12
  }), /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    title: product.category === "recurring" ? content.product["switch"] : content.product.makeRecurring,
    onPress: onEditProduct,
    titleStyle: buttonTitleStyle,
    style: [buttonStyle, accentColour ? {
      backgroundColor: accentColour
    } : {}]
  }), /*#__PURE__*/_react["default"].createElement(_Space["default"], {
    height: 12
  }), !product.expiration && /*#__PURE__*/_react["default"].createElement(_Anchor["default"], {
    style: [cancelStyle ? cancelStyle : styles.cancel, titleColour ? {
      color: titleColour
    } : {}],
    title: content.common.cancel,
    onPress: onCancelProduct
  }));
}
var styles = _reactNative.StyleSheet.create({
  container: _objectSpread({
    padding: 24,
    backgroundColor: _styles.backgroundColors.clear,
    borderRadius: _styles.radius.medium,
    elevation: 8
  }, _styles.shadows.shadowByElevation(8)),
  name: {
    fontSize: 32,
    lineHeight: 48,
    fontWeight: '700',
    color: _styles.colors.feature
  },
  row: {
    flexDirection: 'row'
  },
  column: {
    flex: 1,
    flexDirection: 'column'
  },
  label: {
    fontSize: 14,
    lineHeight: 24
  },
  text: {
    fontSize: 18,
    lineHeight: 24,
    color: _styles.colors.feature
  },
  cancel: {
    color: _styles.colors.trivial,
    textAlign: 'center'
  }
});